import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DrawingMode, ViewerMode } from '../../../types/viewer.types';

@Component({
    selector: 'ts-viewer-tools',
    templateUrl: './viewer-tools.component.html',
    styleUrls: ['./viewer-tools.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ViewerToolsComponent {
  @Input() public readonly availableViewerModes: ViewerMode[];
  @Input() public readonly activeViewerMode: ViewerMode;
  @Input() public readonly availableDrawingModes: DrawingMode[];
  @Input() public readonly activeDrawingMode: DrawingMode;
  @Input() public readonly selectedROIs: Set<string>;
  @Input() public readonly selectedToolIndex: number;

  @Output() public readonly toggleViewerMode = new EventEmitter<ViewerMode>();
  @Output() public readonly toggleDrawingMode = new EventEmitter<DrawingMode>();
  @Output() public readonly removeSelectedROIs = new EventEmitter<void>();

  public ViewerMode = ViewerMode;
  public DrawingMode = DrawingMode;
}
